<div *ngIf="!mlsVerificationInProgress && !isAccountCreated" class="container-fluid" style="overflow-x: hidden">
  <form [formGroup]="signupForm" *ngIf="isSignUpSuccess == false" (ngSubmit)="agentLoSignup()">
    <div class="row h-100">
      <div
        class="col-lg-6 col-md-6 col-sm-6 p-0 d-none d-md-block d-lg-block"
        style="
          background: url(assets/images/welcome-bg.png);
          background-repeat: no-repeat;
          background-size: cover;
          height: 100vh;
        "
      >
        <div class="fixed-image-section">
          <div class="log_base text-center align_v">
            <div class="row">
              <div class="col-lg-12">
                <img class="img-fluid" src="assets\images\Connected-world-amico-3.png" width="350px" />
              </div>
              <div class="clearfix"></div>
              <div class="col-lg-12">
                <h4 class="slide-cont">Engage Buyers & Homeowners in your Market with Prospektr</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-12 white-bg px-0">
        <div class="row partnership_logos">
          <div class="col-lg-12 col-12 px-0">
            <img width="150px" class="img-fluid mx-auto" src="assets/images/logo_72.png" />
            <p class="pb-2">A Complete Buyer & Owner Engagement Platform</p>
            <div class="already-ac pb-3">
              Already have an account? <a class="ac-signin" (click)="goToSignIn()">Sign In</a>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="row form-section mt-3">
          <div class="col-md-12 scrollable-form-wrapper">
            <div class="row">
              <div class="col-lg-8 mx-auto">
                <div class="">
                  <mat-form-field appearance="outline" class="col-md-6">
                    <mat-label>First Name</mat-label>
                    <input
                      type="text"
                      matInput
                      formControlName="firstName"
                      id="firstName"
                      pattern="^[a-zA-Z]+$"
                      aria-describedby="firstName"
                      required
                      placeholder="First Name*"
                    />
                    <mat-error
                      *ngIf="signupControls.firstName.errors && signupControls.firstName.errors.required"
                      class="invalid-feedback"
                    >
                      First Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="signupControls.firstName.errors && signupControls.firstName.errors.maxlength"
                      class="invalid-feedback"
                    >
                      Maximum 25 characters are allowed</mat-error
                    >
                    <mat-error
                      *ngIf="signupControls.firstName.errors && signupControls.firstName.errors.pattern"
                      class="invalid-feedback"
                    >
                      Only alphabets are allowed</mat-error
                    >
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="col-md-6">
                    <mat-label>Last Name</mat-label>
                    <input
                      type="text"
                      matInput
                      formControlName="lastName"
                      id="lastName"
                      pattern="^[a-zA-Z]+$"
                      aria-describedby="lastName"
                      required
                      placeholder="Last Name*"
                    />
                    <mat-error
                      *ngIf="signupControls.lastName.errors && signupControls.lastName.errors.required"
                      class="invalid-feedback"
                    >
                      Last Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="signupControls.lastName.errors && signupControls.lastName.errors.maxlength"
                      class="invalid-feedback"
                    >
                      Maximum 25 characters are allowed</mat-error
                    >
                    <mat-error
                      *ngIf="signupControls.lastName.errors && signupControls.lastName.errors.pattern"
                      class="invalid-feedback"
                    >
                      Only alphabets are allowed</mat-error
                    >
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="col-md-6">
                    <mat-label>Email</mat-label>
                    <input
                      matInput
                      type="email"
                      formControlName="email"
                      id="email"
                      aria-describedby="email"
                      required
                      placeholder="Email*"
                    />
                    <mat-error
                      *ngIf="signupControls.email.errors && signupControls.email.errors.required"
                      class="invalid-feedback"
                      >Email is required</mat-error
                    >
                    <mat-error
                      *ngIf="signupControls.email.errors && signupControls.email.errors.pattern"
                      class="invalid-feedback"
                      >Email must be a valid</mat-error
                    >
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="col-md-6">
                    <mat-label>Phone</mat-label>
                    <input
                      matInput
                      formControlName="phone"
                      id="phone"
                      aria-describedby="phone"
                      required
                      placeholder="Phone*"
                      [mask]="fieldConfig['phone']?.mask"
                      [dropSpecialCharacters]="true"
                    />
                    <mat-error
                      *ngIf="signupControls.phone.errors && signupControls.phone.errors.required"
                      class="invalid-feedback"
                      aria-label="phone No. is required"
                    >
                      Phone No. is required
                    </mat-error>
                    <mat-error
                      *ngIf="signupControls.phone.errors && signupControls.phone.errors.pattern"
                      class="invalid-feedback"
                    >
                      Phone number must be valid
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="col-md-12">
                    <mat-label>Company Name</mat-label>
                    <input
                      matInput
                      type="text"
                      id="companyName"
                      formControlName="companyName"
                      placeholder="Company Name"
                      required
                    />
                    <mat-error
                      *ngIf="signupControls.companyName.errors && signupControls.companyName.errors.required"
                      class="invalid-feedback"
                    >
                      Company Name is required
                    </mat-error>
                    <mat-error
                      *ngIf="signupControls.companyName.errors && signupControls.companyName.errors.minlength"
                      class="invalid-feedback"
                    >
                      Company Name must be at least 6 characters</mat-error
                    >
                    <mat-error
                      *ngIf="signupControls.companyName.errors && signupControls.companyName.errors.pattern"
                      class="invalid-feedback"
                    >
                      Company Name must begin with a capital letter and contain only letters</mat-error
                    >
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="full-width col-md-12">
                    <mat-label>Subdomain</mat-label>

                    <input
                      type="text"
                      matInput
                      formControlName="subdomain"
                      [matAutocomplete]="auto"
                      placeholder="Enter subdomain"
                    />

                    <span matSuffix class="text-muted sub-domain">.prospektr.ai</span>

                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onDomainSelected($event.option.value)">
                      <mat-option *ngFor="let domain of filteredDomains" [value]="domain">
                        {{ domain }}
                      </mat-option>
                    </mat-autocomplete>

                    <mat-spinner *ngIf="isLoadingdomains == true" diameter="20" strokeWidth="3"></mat-spinner>

                    <mat-error
                      *ngIf="signupControls.subdomain.errors && signupControls.subdomain.errors.required"
                      class="invalid-feedback"
                    >
                      Subdomain is required
                    </mat-error>
                  </mat-form-field>
                  <div class="col-md-12">
                    <div class="info-txt subdomain-note text-left py-2">
                      <mat-icon class="info-icon">info</mat-icon>You will get a dedicated url for Prospektr such as
                      mybrokerage.prospektr.ai. If you want to make it your own domain such as www.mybrokerage.com -
                      please complete the signup and reach out to us at support@propmix.io
                    </div>
                  </div>

                  <mat-form-field class="btn-block col-md-12" appearance="outline">
                    <mat-label> Business Area</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="businessArea"
                      name="autocompleteInput"
                      class="search_field"
                      #searchField
                      [(ngModel)]="autoCompleteInput"
                      required
                      tabindex="2"
                      googleAutocomplete
                      autocomplete="off"
                      (addressComponents)="getAddressComponents($event)"
                    />
                    <mat-error
                      class="invalid-feedback ml-2"
                      *ngIf="f.businessArea.errors && f.businessArea.errors.message"
                    >
                      {{ f.businessArea.errors.message }}</mat-error
                    >
                  </mat-form-field>

                  <div class="col-md-12">
                    <div class="info-txt subdomain-note text-left py-2">
                      <mat-icon class="info-icon">info</mat-icon>City and State where you do most business. You can add
                      more business areas after you finish signing up.
                    </div>
                  </div>

                  <mat-form-field appearance="outline" class="col-md-6 password-field">
                    <mat-label>Password</mat-label>
                    <input
                      matInput
                      [type]="hidePassword ? 'password' : 'text'"
                      formControlName="password"
                      class="pass-fld"
                      aria-describedby="password"
                      placeholder="Password*"
                      required
                    />

                    <!-- 👁 Toggle button -->
                    <button
                      mat-icon-button
                      matSuffix
                      type="button"
                      (click)="hidePassword = !hidePassword"
                      [attr.aria-label]="'Toggle password visibility'"
                      [attr.aria-pressed]="!hidePassword"
                    >
                      <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>

                    <mat-error *ngIf="signupControls.password.hasError('required')"> Password is required </mat-error>

                    <mat-error
                      *ngIf="
                        !signupControls.password.hasError('required') && signupControls.password.hasError('minlength')
                      "
                    >
                      Password must be at least 8 characters
                    </mat-error>

                    <mat-error
                      *ngIf="
                        !signupControls.password.hasError('required') &&
                        !signupControls.password.hasError('minlength') &&
                        signupControls.password.hasError('maxlength')
                      "
                    >
                      Password cannot exceed 20 characters
                    </mat-error>

                    <mat-error
                      *ngIf="
                        !signupControls.password.hasError('required') &&
                        !signupControls.password.hasError('minlength') &&
                        !signupControls.password.hasError('maxlength') &&
                        signupControls.password.hasError('uppercase')
                      "
                    >
                      Password must include at least 1 uppercase letter
                    </mat-error>

                    <mat-error
                      *ngIf="
                        !signupControls.password.hasError('required') &&
                        !signupControls.password.hasError('minlength') &&
                        !signupControls.password.hasError('maxlength') &&
                        !signupControls.password.hasError('uppercase') &&
                        signupControls.password.hasError('lowercase')
                      "
                    >
                      Password must include at least 1 lowercase letter
                    </mat-error>

                    <mat-error
                      *ngIf="
                        !signupControls.password.hasError('required') &&
                        !signupControls.password.hasError('minlength') &&
                        !signupControls.password.hasError('maxlength') &&
                        !signupControls.password.hasError('uppercase') &&
                        !signupControls.password.hasError('lowercase') &&
                        signupControls.password.hasError('number')
                      "
                    >
                      Password must include at least 1 number
                    </mat-error>

                    <mat-error
                      *ngIf="
                        !signupControls.password.hasError('required') &&
                        !signupControls.password.hasError('minlength') &&
                        !signupControls.password.hasError('maxlength') &&
                        !signupControls.password.hasError('uppercase') &&
                        !signupControls.password.hasError('lowercase') &&
                        !signupControls.password.hasError('number') &&
                        signupControls.password.hasError('specialCharacter')
                      "
                    >
                      Password must include at least 1 special character
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="col-md-6 password-field">
                    <mat-label>Confirm Password</mat-label>
                    <input
                      matInput
                      type="password"
                      id="confirmPassword"
                      formControlName="confirmPassword"
                      placeholder="Confirm Password*"
                      (input)="onConfirmPasswordInput()"
                      required
                    />
                    <mat-error
                      *ngIf="signupControls.confirmPassword.errors && signupControls.confirmPassword.errors.required"
                      class="invalid-feedback"
                    >
                      Confirm Password is required
                    </mat-error>
                    <mat-error
                      *ngIf="signupControls.confirmPassword.errors && signupControls.confirmPassword.errors.minlength"
                      class="invalid-feedback"
                    >
                      Confirm Password must be at least 8 characters</mat-error
                    >
                    <mat-error *ngIf="signupControls.confirmPassword.errors?.maxlength" class="invalid-feedback">
                      Confirm Password cannot exceed 20 characters
                    </mat-error>
                    <mat-error
                      *ngIf="
                        signupControls.confirmPassword.hasError('passwordMismatch') &&
                        signupControls.confirmPassword.dirty
                      "
                      class="invalid-feedback"
                    >
                      Passwords do not match.
                    </mat-error>
                  </mat-form-field>

                  <div class="col-md-12">
                    <div class="info-txt subdomain-note text-left py-2">
                      <mat-icon class="info-icon">info</mat-icon> Password must be 8–20 characters and include
                      uppercase, lowercase, number, and special character.
                    </div>
                  </div>

                  <mat-form-field appearance="outline" class="col-md-12">
                    <mat-label>Role</mat-label>
                    <mat-select formControlName="role" required (selectionChange)="onRoleChange($event.value)">
                      <mat-option value="" disabled>Select Role</mat-option>
                      <mat-option value="agent">Agent</mat-option>
                      <mat-option value="loanOfficer">Loan Officer</mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="signupControls.role.errors && signupControls.role.errors.required"
                      class="invalid-feedback"
                    >
                      Role is required
                    </mat-error>
                  </mat-form-field>

                  <div *ngIf="signupForm.get('role')?.value === 'agent'">
                    <h6 class="addressLabelCls pl-3 pb-3 pt-1 text-left">MLS Access Information <span> * </span></h6>
                    <div formGroupName="mlsInfoForm">
                      <div class="formWrapper">
                        <mat-form-field appearance="outline" class="form-dropdown-field">
                        <mat-label>State</mat-label>
                        <mat-select formControlName="state" (selectionChange)="onStateSelection($event)">
                          <mat-option value="" disabled> Select State </mat-option>
                          <mat-option *ngFor="let state of stateList | keyvalue" [value]="state.key">
                            {{ state.value | titlecase }} - {{ state.key | uppercase }}
                          </mat-option>
                        </mat-select>
                        <!-- <mat-error
                         
                          class="invalid-feedback"
                        >
                          State is required
                        </mat-error> -->
                        <!-- <mat-error
                          *ngIf="
                            showMlsValidation &&
                            !mlsInfoForm.get('state')?.value
                          "
                          class="invalid-feedback"
                        >
                          State is required
                        </mat-error> -->
                                              </mat-form-field>
                                  <mat-error
                          *ngIf="
                            showMlsValidation &&
                            !mlsInfoForm.get('state')?.value
                          "
                          class="invalid-feedback"
                        >
                          State is required
                        </mat-error>
                      </div>
                      
                      
                      <div class="formWrapper">
                        <mat-form-field
                        appearance="outline"
                        [ngClass]="{ 'select-progress': isLoadingStateMLS }" class="form-dropdown-field"
                      >
                        <mat-label>MLS Board</mat-label>
                        <mat-select [disabled]="isLoadingStateMLS" formControlName="mlsBoard">
                          <mat-option value="" disabled>Select MLS Board</mat-option>
                          <mat-option *ngFor="let mls of stateMlsList" [value]="mls.MLSBoard">
                            {{ mls.MLSBoard }} - {{ mls.MLSName }}
                          </mat-option>
                          <mat-option value="" *ngIf="!isLoadingStateMLS && !stateMlsList.length"
                            >No MLSBoard</mat-option
                          >
                        </mat-select>
                        <mat-spinner [diameter]="20" strokeWidth="3" *ngIf="isLoadingStateMLS"></mat-spinner>
                      </mat-form-field>
                         <mat-error style="left: 5px;"
                          *ngIf="
                            showMlsValidation &&
                            !mlsInfoForm.get('mlsBoard')?.value
                          "
                          class="invalid-feedback"
                        >
                          MlsBoard is required
                        </mat-error>
                      </div>
                      

                      <div class="form-row" style="margin-left: 0.75rem !important">
                        <div class="form-group col-md-9 mb-0" style="display: flex; align-items: center">
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Membership Number</mat-label>
                            <input
                              matInput
                              type="text"
                              id="membershipNumber"
                              formControlName="memberId"
                              placeholder="Membership Number*"
                            />
                             
                          
                          </mat-form-field>
                  <mat-error
  *ngIf="
    showMlsValidation &&
    !mlsInfoForm.get('memberId')?.value
  "
   class="invalid-feedback"
>
  Member ID is required
</mat-error>
                        </div>
                        <div class="form-group col-md-3">
                          <button
                            mat-flat-button
                            type="button"
                            class="btn btn-primary blueBtn add"
                            (click)="addMlsInfo()"
                           
                          >
                            + ADD
                          </button>
                        </div>
                        <div class="col-md-12">
                          <div class="info-txt mls-note text-left">
                            <mat-icon class="info-icon">info</mat-icon>To help us validate your membership with the MLS,
                            please provide your MLS Membership Number.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="" *ngIf="mlsInformation.data && mlsInformation.data.length > 0">
                    <div class="col-md-12">
                      <div class="table_base table-container mt-3 mb-3 mls-list">
                        <div class="table-responsive table_wrap">
                          <mat-spinner *ngIf="isLoadingAgentMLS" class="loading-spinner"></mat-spinner>
                          <table
                            mat-table
                            [dataSource]="mlsInformation"
                            class="mat-elevation-z2 w-100"
                            *ngIf="mlsInformation.data && mlsInformation.data.length > 0"
                          >
                            <ng-container matColumnDef="state">
                              <th mat-header-cell *matHeaderCellDef>State</th>
                              <td mat-cell *matCellDef="let element">
                                <!-- {{ stateList[element.state] | titlecase }} -->
                                  {{  element.state  | uppercase  }}
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="mlsBoard">
                              <th mat-header-cell *matHeaderCellDef>MLS</th>
                              <td mat-cell *matCellDef="let element">
                                {{ element.mlsBoard }}
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="memberId">
                              <th mat-header-cell *matHeaderCellDef>Membership ID</th>
                              <td mat-cell *matCellDef="let element">
                                {{ element.memberId }}
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                              <th mat-header-cell *matHeaderCellDef>Status</th>
                              <td
                                mat-cell
                                *matCellDef="let element"
                                [ngClass]="{ incomplete: element.status === 'invalid' }"
                              >
                                {{ element.status === 'invalid' ? 'Pending' : 'Success' }}
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="action">
                              <th mat-header-cell *matHeaderCellDef class="actionsWrap">Actions</th>
                              <td mat-cell *matCellDef="let element" class="actionsWrap">
                                <button type="button" mat-icon-button aria-label="delete" class="delete">
                                  <i class="material-icons" style="font-size: 20px" (click)="deleteMLS(element)">
                                    delete
                                  </i>
                                </button>
                              </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="mlsTableColumnList"></tr>
                            <tr mat-row *matRowDef="let row; columns: mlsTableColumnList"></tr>
                            <mat-spinner [diameter]="20" strokeWidth="3" *ngIf="isLoadingAgentMLS"></mat-spinner>
                          </table>
                        </div>
                      </div>

                      <div class="row">
                        <div
                          class="py-2 text-left col-md-12"
                          style="padding-left: 15px; line-height: 1.5"
                          *ngIf="showMlsInvalidMessage && appState.appCompanyAliasValue == 'valuetest'"
                        >
                          We’re unable to verify the number you entered as an MLS Member ID. Please ensure you’re not
                          entering your license number.<br />
                          If verification still doesn’t work, you can proceed with account creation and then call us at
                          <b>(702) 591-7245</b> to complete any pending verification. – PropMix
                        </div>
                        <div
                          class="py-2 text-left col-md-12"
                          style="padding-left: 15px; line-height: 1.5"
                          *ngIf="showMlsInvalidMessage && appState.appCompanyAliasValue != 'valuetest'"
                        >
                          Your MLS membership details couldn’t be verified. Please check your Membership ID. If you’re
                          still unable to verify, don’t worry —
                          <b>Our support team will review your details and get back to you within 24 hours. </b> Please
                          go ahead and submit the form.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="flex_center w-100" *ngIf="!isLoadingAgentMLS && !mlsInformation.data">
                    <div class="notFound text-center noData">
                      <div>
                        <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                        <h4>No MLS memberships found</h4>
                      </div>
                    </div>
                  </div>

                  <div class="continue col-md-12" #scrollTarget>
                    <button
                      mat-flat-button
                      type="submit"
                      class="btn btn-primary btn-block blueBtn my-3"
                      *ngIf="
                        signupForm.valid &&
                        (signupForm.get('role')?.value !== 'agent' ||
                          (signupForm.get('role')?.value === 'agent' && mlsInformation.data.length !== 0))
                      "
                    >
                      <ng-container *ngIf="!isUserAuthenticationProgress"> Create Account </ng-container>
                      <span *ngIf="isUserAuthenticationProgress"
                        >&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i> Creating...</span
                      >
                    </button>
                  </div>
                  <div class="col-md-12">
                    <div class="info-txt mls-note text-left mt-2">
                      <b
                        >@ By registering for a Prospektr account, you will be added to our roster of clients utilizing
                        MLS data. Your MLS may require the execution of an IDX or data access agreement to ensure
                        compliance with their data usage policies. We will let you know if your MLS needs you to
                        complete this process.</b
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row poweredby">
          <div class="col-lg-12">
            <p class="pl-4">Powered by <img class="center" src="assets/images/propmix_logo.png" /></p>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="container-fluid" *ngIf="isAccountCreated && isSignUpSuccess == false">
  <form [formGroup]="signupForm" (ngSubmit)="agentLoSignup()">
    <div class="row h-100" style="overflow-x: hidden">
      <div
        class="col-lg-6 col-md-6 col-sm-6 p-0 d-none d-md-block d-lg-block"
        style="
          background: url(assets/images/welcome-bg.png);
          background-repeat: no-repeat;
          background-size: cover;
          height: 100vh;
        "
      >
        <div class="fixed-image-section">
          <div class="log_base text-center align_v">
            <div class="row">
              <div class="col-lg-12">
                <img class="img-fluid" src="assets\images\Connected-world-amico-3.png" width="350px" />
              </div>
              <div class="clearfix"></div>
              <div class="col-lg-12">
                <h4 class="slide-cont">Engage Buyers & Homeowners in your Market with Prospektr</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-12 white-bg px-0">
        <div class="row partnership_logos">
          <div class="col-lg-12 col-12 px-0">
            <img width="180px" class="img-fluid mx-auto" src="assets/images/logo_72.png" />
            <p>A Complete Buyer & Owner Engagement Platform</p>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="row form-section">
          <div class="col-lg-8 mx-auto">
            <h3 class="pt-5">Account Creation in Progress</h3>
            <p class="note-txt">
              Thank you for signing up! Your trial account is being created, and you'll receive an activation email
              shortly. Please check your inbox (and spam folder just in case).
            </p>
            <button
              mat-flat-button
              type="button"
              class="btn btn-primary blueBtn add col-md-12 mt-3"
              (click)="isAccountCreated = false"
            >
              Back to Home
            </button>
          </div>
        </div>
        <div class="row poweredby">
          <div class="col-lg-12">
            <p class="pl-4">Powered by <img class="center" src="assets/images/propmix_logo.png" /></p>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="container-fluid" *ngIf="mlsVerificationInProgress && isSignUpSuccess == false">
  <form [formGroup]="signupForm" (ngSubmit)="agentLoSignup()">
    <div class="row h-100" style="overflow-x: hidden">
      <div
        class="col-lg-6 col-md-6 col-sm-6 p-0 d-none d-md-block d-lg-block"
        style="
          background: url(assets/images/welcome-bg.png);
          background-repeat: no-repeat;
          background-size: cover;
          height: 100vh;
        "
      >
        <div class="fixed-image-section">
          <div class="log_base text-center align_v">
            <div class="row">
              <div class="col-lg-12">
                <img class="img-fluid" src="assets\images\Connected-world-amico-3.png" width="350px" />
              </div>
              <div class="clearfix"></div>
              <div class="col-lg-12">
                <h4 class="slide-cont">Engage Buyers & Homeowners in your Market with Prospektr</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-12 white-bg px-0">
        <div class="row partnership_logos">
          <div class="col-lg-12 col-12 px-0">
            <img width="180px" class="img-fluid mx-auto" src="assets/images/logo_72.png" />
            <p>A Complete Buyer & Owner Engagement Platform</p>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="row form-section">
          <div class="col-lg-8 mx-auto">
            <h3 class="pt-5">Your Account Creation is in Progress</h3>
            <p class="note-txt">
              Thank you for signing up! We're currently verifying your MLS details. You'll receive an account activation
              email within 24 hours.
            </p>
            <button
              mat-flat-button
              type="button"
              class="btn btn-primary blueBtn add col-md-12 mt-3"
              (click)="backToHome()"
            >
              Back to Home
            </button>
          </div>
        </div>
        <div class="row poweredby">
          <div class="col-lg-12">
            <p>Powered by <img class="center" src="assets/images/propmix_logo.png" /></p>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="container-fluid" *ngIf="isSignUpSuccess == true">
  <div class="row h-100">
    <div
      class="col-lg-6 col-md-6 col-sm-6 p-0 d-none d-md-block d-lg-block"
      style="
        background: url(assets/images/welcome-bg.png);
        background-repeat: no-repeat;
        background-size: cover;
        height: 100vh;
      "
    >
      <div class="fixed-image-section">
        <div class="log_base text-center align_v">
          <div class="row">
            <div class="col-lg-12">
              <img class="img-fluid" src="assets\images\Connected-world-amico-3.png" width="350px" />
            </div>
            <div class="clearfix"></div>
            <div class="col-lg-12">
              <h4 class="slide-cont">Engage Buyers & Homeowners in your Market with Prospektr</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6 col-md-6 col-sm-6 col-12 white-bg px-0" style="overflow-x: hidden">
      <div class="row partnership_logos">
        <div class="col-lg-12 col-12 px-0">
          <img width="150px" class="img-fluid mx-auto" src="assets/images/logo_72.png" />
          <p class="pb-2">A Complete Buyer & Owner Engagement Platform</p>
        </div>
      </div>
      <div class="clearfix"></div>

      <div class="row form-section">
        <div class="col-lg-8 mx-auto">
          <img height="80px" src="assets/images/check.png" />
          <h3 class="mt-3">Account Created Successfully!</h3>
          <p class="note-txt mb-3">
            Welcome to Prospektr — your workspace is ready. We've sent a verification email to your registered email
            address. Verifying your email helps unlock all features and ensures secure access to your account.
          </p>
          <div class="d-flex justify-content-center gap-2">
            <!-- <button mat-button color="primary" (click)="goBack()"><mat-icon>arrow_back</mat-icon>Go Back</button> -->
            <button mat-flat-button color="primary" class="blueBtn add" (click)="getStart()">Get Started</button>
          </div>
        </div>
      </div>
      <!-- <div class="row form-section mt-3">
        <div class="col-md-12 scrollable-form-wrapper">
          <div class="row">
            <div class="col-lg-8 mx-auto"></div>
          </div>
          <p>Account Created Successfully!</p>
          <p>Welcome to Prospektr — your workspace is ready.</p>
          <p>We've sent a verification email to your registered email address.</p>
          <p>Verifying your email helps unlock all features and ensures secure access to your account.</p>
          <div class="row">
            <div class="col-md-12">
              <button mat-button color="primary" class="float-right" (click)="goBack()" name="reset search">
                Go Back
              </button>
              <button mat-button color="primary" class="float-right" (click)="getStart()" name="reset search">
                Get Started
              </button>
            </div>
          </div>
        </div>
      </div> -->
      <div class="row poweredby">
        <div class="col-lg-12">
          <p class="pl-4">Powered by <img class="center" src="assets/images/propmix_logo.png" /></p>
        </div>
      </div>
    </div>
  </div>
</div>
